namespace Gordic.Epk.WebControls {

    /** Posledně použité dokumenty */
    export class EpkLastUsed {

        public getItem(lastUsed: any[], cnt: GContentType<any>) {

            var getDataLastUsedopt = {
                LastUsed: lastUsed
            };

            var result = Gordic.Ssl.Utils.GetDataLastUsed(getDataLastUsedopt);

            var opt: IGDashboardPanelOptions = {
                id: "lastModifiedDocs",
                title: "jres:32000752", //RC 32000752 : Posledně použité
                // @ts-ignore
                zone: 1,
                mode: "vertical",
                itemTemplate: (data) => {
                    var res = Gordic.Prefabs.Panels.kpiIconTwoRowsTextTemplate().itemTemplate(data) as JQuery<HTMLElement>;

                    $(res).addClass("epk-card-c").click((ev) => {
                        ev.preventDefault();
                        Gordic.Ssl.Dialogs.Detail(cnt, { DetailDto: { ixp: data.ixp } }); 
                    });

                    return res;
                },
                defaultSelected: false,
                //defaultAction: new GAction({
                //    name: "actLastUsedClickEnter",
                //    run: function (ev, ctx) {
                //        var ixp = ctx.item.data.ixp;
                //        Gordic.Ssl.Dialogs.Detail(cnt, { DetailDto: { ixp: ixp } }); //, Gordic.Global.Enums.ModOtevreni.navigateTask
                //    }
                //}),
                data: new Gordic.Data.View(result),
            };

            //var lastUsedItems = new Gordic.Data.View([
            //    (scoreBoardItems != null && scoreBoardItems.length > 0) ? scoreBoardItems[0] : null,
            //    opt
            //], { key: ["id"] });

            return opt;

        }

    }

}